<div class="drawer-container">
  <div class="rectangle"></div>

  <div class="sheet-body">
    <div class="sheet-data">
      <div class="sheet-header">
        {{ "APP.TICKETS_DASHBOARD.ASSIGN_TICKET" | translate }}
      </div>
      <div class="sheet-desc">
        @if(ticket?.eventAttendeeTicketOrder?.eventSlot?.accountRequirement === AccountRequirement.REQUIRED){
          {{ "APP.TICKETS_DASHBOARD.FORWARD_TICKET_DESC" | translate }}
        }

        {{ "APP.TICKETS_DASHBOARD.SHARE_THIS_TICKET" | translate }}
      </div>
    </div>

    <form [formGroup]="form">
      <mat-form-field appearance="outline" class="w-100 email-field">
        <mat-label>{{ "APP.EMAIL" | translate }}</mat-label>
        <input type="text" matInput formControlName="email" placeholder="" />
      </mat-form-field>
    </form>

    <div class="sheet-actions">
      <button class="btn btn-primary" (click)="sendUnassignedTicket()">
        {{ "APP.TICKETS_DASHBOARD.SEND_TICKET" | translate }}
      </button>
      @if(showAssignToMe){
        <button class="btn btn-primary-outline" (click)="openClaimTicketDialog()">
          {{ "APP.TICKETS_DASHBOARD.ASSIGN_TO_ME" | translate }}
        </button>
      }
      <button
        class="btn btn-primary-text"
        type="button"
        (click)="copyTicketForwardLink()"
      >
        {{ "APP.TICKETS_DASHBOARD.COPY_AS_LINK" | translate }}
      </button>
    </div>
  </div>
</div>
